import { GraphSchema } from '@camelot/server';
import { Project } from '@camelot/services';

import { Company } from '../../../organization/services/dto/company';
import { Department } from '../../../organization/services/dto/department';

export interface PurchaseOrderProfile {
  id: string;
  reference: string | null;
  company: Pick<Company, 'id' | 'name'> | null;
  department: Pick<Department, 'id' | 'name'> | null;
  project: Pick<Project, 'id' | 'name'> | null;
}

export const purchaseOrderProfileProps = new GraphSchema<PurchaseOrderProfile>([
  'id',
  'reference',
  'company',
  'department',
  'project',
]);
